import React from 'react';
import { Link } from 'react-router-dom';
import { useCustomerAuth } from '../lib/customerAuth';
import { resolveProductPrice, resolveProductUnitPrice, getMrp, formatInr } from '../lib/pricing';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { ShoppingCart } from 'lucide-react';
import { SafeImage } from './SafeImage';

export default function ProductCard({ product }) {
    const { customer } = useCustomerAuth();
    const resolved = resolveProductUnitPrice(product, customer?.type, customer?.level);
    const price = resolved.price;
    const unitCode = resolved.unit_code;
    const mrp = resolved.mrp || getMrp(product, customer?.type);
    const discount = mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0;
    const outOfStock = (product.inventory?.available || 0) <= 0;
    return (
        <Link to={`/product/${product.slug || product.id}`} className="group" data-testid={`product-card-${product.sku}`}>
            <Card className="overflow-hidden hover:shadow-lg transition-shadow border">
                <div className="aspect-square bg-neutral-100 overflow-hidden relative">
                    <SafeImage
                        src={product.images?.[0]}
                        alt={product.name}
                        className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                        iconClassName="h-10 w-10"
                    />
                    {discount > 0 && (
                        <Badge className="absolute top-2 left-2" style={{ background: 'hsl(142 71% 45%)', color: 'white' }}>{discount}% OFF</Badge>
                    )}
                    {outOfStock && (
                        <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                            <span className="bg-white text-neutral-800 text-xs font-semibold px-3 py-1 rounded-full">Out of stock</span>
                        </div>
                    )}
                </div>
                <div className="p-3 sm:p-4">
                    <div className="text-sm font-medium text-neutral-900 line-clamp-1">{product.name}</div>
                    {product.short_description && (
                        <div className="text-xs text-neutral-500 mt-0.5 line-clamp-1">{product.short_description}</div>
                    )}
                    <div className="mt-2 flex items-baseline gap-2 flex-wrap">
                        <span className="text-base font-semibold text-neutral-900">{formatInr(price)}</span>
                        <span className="text-[11px] text-neutral-500">/ {unitCode}</span>
                        {mrp > price && <span className="text-xs text-neutral-500 line-through">{formatInr(mrp)}</span>}
                    </div>
                    <div className="mt-2 flex items-center justify-between">
                        <span className="text-xs text-neutral-500">SKU: {product.sku}</span>
                        <span className="text-xs text-brand-green flex items-center gap-1" style={{ color: 'hsl(142 71% 35%)' }}>
                            <ShoppingCart className="h-3.5 w-3.5" /> Add
                        </span>
                    </div>
                </div>
            </Card>
        </Link>
    );
}
